import { Typography, Box } from '@mui/material';
import { useMemo } from 'react';
import {
  ChildContainerItem,
  InfiniteScrollList,
  InfiniteScrollListItem,
  SearchField,
} from 'components/BusinessListNew/styles';
import { LabelName } from 'pages/Report/styles';
import usePermission from 'hooks/permission';
import * as all from 'constants/permissions';
import { useTranslation } from 'react-i18next';
import useLocationList from './hooks/useLocationList';
import Preloader from 'components/Preloader';

const styles = {
  minHeight: 208,
  maxHeight: 208,
  overflowY: 'auto',
  border: '1px solid #eee',
  borderRadius: '4px',
};

const LocationListItems = (props) => {
  const {
    locationList,
    //locationChange,
    //handleLocationChange,
    // selectedLocations,
    selectedLocation,
    selectedBrand,
    selectedLocationId,
    onKeyDown,
    isSearch: brandIsSearch,
    searchValue: brandSearchValue,
    searchLoading,
    isShowOnlyLoading,
  } = props;

  const { t } = useTranslation();
  const checkPermission = usePermission();

  const {
    displayLocationList,
    handleLocationChange,
    handleLocationSelect,
    searchValue,
    activeLocation,
    mappedLocations,
  } = useLocationList(locationList, selectedLocationId, selectedLocation);

  const renderListItems = useMemo(() => {
    if (searchLoading || isShowOnlyLoading) {
      return (
        <InfiniteScrollListItem sx={{ textAlign: 'center', mt: 4 }}>
          <Preloader overlay={true} />
        </InfiniteScrollListItem>
      );
    }

    if (!displayLocationList?.length) {
      return (
        <InfiniteScrollListItem sx={{ textAlign: 'center', color: '#c7c4c4' }}>
          No options
        </InfiniteScrollListItem>
      );
    }

    return displayLocationList.map((item, index) => {
      const locationDetails = `${item.locationName} ${
        item?.disabled ? '(Disabled)' : ''
      } ${!item?.verified ? '(Pending)' : ''}`;
      const classificationsText =
        item?.classifications?.length > 0
          ? `${mappedLocations(item?.classifications)}`
          : '';
      const typographyContent = checkPermission(all['SUPER'])
        ? `${locationDetails} ${classificationsText}`
        : locationDetails;

      const isActive = activeLocation(item) === 'active-location';

      return (
        <InfiniteScrollListItem
          onClick={() => handleLocationSelect(item)}
          className={activeLocation(item)}
          key={`${item?.locationName}-${index}`}
          sx={{
            color: isActive ? '#fff' : 'inherit',
            backgroundColor: isActive ? 'rgb(38, 132, 255)' : 'initial',
            '&:hover': {
              backgroundColor: isActive
                ? 'rgb(38, 132, 255)'
                : 'rgb(222, 235, 255)',
            },
          }}
        >
          <Typography>{typographyContent}</Typography>
          <Typography sx={{ fontSize: '12px' }}>{item.address}</Typography>
        </InfiniteScrollListItem>
      );
    });
  }, [
    displayLocationList,
    searchLoading,
    isShowOnlyLoading,
    mappedLocations,
    checkPermission,
    activeLocation,
    handleLocationSelect,
  ]);

  return (
    <ChildContainerItem>
      <LabelName>{t('reports_settings.all_locations')}</LabelName>
      <SearchField
        onKeyDown={onKeyDown}
        disabled={checkPermission(all['SUPER'])}
        multiline
        onChange={(e) => handleLocationChange(e)}
        placeholder={t('reports_settings.all_locations_...')}
        value={searchValue}
        variant="outlined"
        size="small"
        sx={{
          marginBottom: '4px',
        }}
      />
      <Box sx={styles}>
        <InfiniteScrollList>{renderListItems}</InfiniteScrollList>
      </Box>
    </ChildContainerItem>
  );
};

export default LocationListItems;
